import secureLocalStorage from "react-secure-storage";
const getLocalRefreshToken = () => {
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  console.log("The refresh Token is ");
  console.log(user.refresh_token);
  return user?.refresh_token;
};

const getLocalAccessToken = () => {
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  return user?.token;
};

const updateLocalAccessToken = (token) => {
  let user = JSON.parse(secureLocalStorage.getItem("user"));
  user.token = token;
  secureLocalStorage.setItem("user", JSON.stringify(user));
};

const updateLocalRefreshToken = (token) => {
  let user = JSON.parse(secureLocalStorage.getItem("user"));
  user.refresh_token = token;
  secureLocalStorage.setItem("user", JSON.stringify(user));
};

const getUser = () => {
  return JSON.parse(secureLocalStorage.getItem("user"));
};

const setUser = (user) => {
  secureLocalStorage.setItem("user", JSON.stringify(user));
};

const removeUser = () => {
  secureLocalStorage.removeItem("user");
};

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  updateLocalRefreshToken,
  getUser,
  setUser,
  removeUser,
};

export default TokenService;
